export const SAVE_TOKEN = "saveToken";
export const SAVE_AUTH_FROM_SESSION ="saveFromSession";
export const FETCH_USER_PROFILE = "fetchUserProfile";
export const CLEAR_USER_PROFILE = "clearUserProfile";